module.exports = __webpack_public_path__ + "static/img/product-5.fd69002.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-5.png
// module id = YDkX
// module chunks = 1